import { Grid, Typography } from '@material-ui/core';
import ImProductOutputManagement from 'components/organisms/ImProductOutputManagement';
import AdminTemplate from 'components/templates/AdminTemplate';

const IMInventoryOutput: React.FC = () => (
  <AdminTemplate>
    <Grid container justify="center" spacing={2}>
      <Grid item xs={12} sm={12} style={{ marginBottom: 10 }}>
        <Typography variant="h5" component="h1" align="center">
          Gestión de Salidas
        </Typography>
      </Grid>
    </Grid>
    <ImProductOutputManagement />
  </AdminTemplate>
);

export default IMInventoryOutput;
